import { FormWMSInventario } from '../../../components/Forms/WMSInventario'

export function WMSNovoInventario() {
  return <FormWMSInventario />
}
